






































import { Component, Vue } from 'vue-property-decorator';
import EyeIcon from './EyeIcon.vue';

@Component({
  components: { EyeIcon },
  props: {
    hasRules: {
      type: Boolean,
      default: false
    },
    inputLabel: {
      type: String,
      default: 'Password'
    },
    isIncorrect: {
      type: Boolean,
      default: false
    }
  }
})
export default class PasswordField extends Vue {
  showPassword = false;

  password = '';

  get passwordInputType(): string {
    return this.showPassword ? 'text' : 'password';
  }

  eyeClickHandler(value: boolean) {
    this.showPassword = !value;
  }

  passwordInputHandler(password: string): void {
    this.password = password;
    this.$emit('updated', password);

    const isValidPassword = this.validatePassword();

    if (isValidPassword) {
      this.$emit('validated', true);
    } else {
      this.$emit('validated', false);
    }
  }

  validatePassword() {
    if (this.$props.hasRules) {
      return !this.isContainingSpaces && this.isPasswordMatchPattern;
    }
    return true;
  }

  get isContainingSpaces() {
    return new RegExp(/\s/gi).test(this.password);
  }

  get isPasswordMatchPattern() {
    return this.password.length > 0 && new RegExp(/\S{7,}/gi).test(this.password);
  }

  hideErrorMessage(): void {
    this.$emit('hidePasswordErrorMessage', true);
  }
}
